(() => {
  const root = document.querySelector('[data-wl-root]');
  if (!root) return;


  const mount = root.querySelector('[data-wl-mount]');
  const empty = root.querySelector('[data-wl-empty]');
  const source = root.querySelector('[data-wl-wk-source]');

  const CARD_SECTION = 'wl-wishlist-card'; // ②で作るセクション名

  // /products/xxxxx?variant=... から handle を抜く
  const extractHandle = (href) => {
    try {
      const u = new URL(href, location.origin);
      const m = u.pathname.match(/^\/products\/([^\/]+)/);
      return m ? m[1] : null;
    } catch(e) {
      return null;
    }
  };

  // 共有リンクで開かれた場合は、URLの商品リストを使う（受け取った人は自分のお気に入りに関係なく見られる）
  const params = new URLSearchParams(location.search);
  const sharedParam = params.get('shared');
  const sharedHandles = sharedParam
    ? sharedParam.split(',').map((s) => s.trim()).filter(Boolean)
    : null;
  const isShared = !!(sharedHandles && sharedHandles.length);

  // デモ表示（テスト確認用）：お気に入りが無くても、URLの商品リストで全機能を試せる。
  // 共有と違い読み取り専用にせず、絞り込み・選択・共有・相談をすべて有効にする。
  const demoParam = params.get('demo');
  const demoHandles = demoParam
    ? demoParam.split(',').map((s) => s.trim()).filter(Boolean)
    : null;
  const isDemo = !isShared && !!(demoHandles && demoHandles.length);

  const getHandlesFromWK = () => {
    if (isShared) return sharedHandles.slice();
    if (isDemo) return demoHandles.slice();
    // 内製お気に入り：標準は新core（端末＋会員サーバー）から読む。?favold=1 で旧Swishに戻せる
    if (params.get('favold') !== '1' && window.__kidoFav) {
      return window.__kidoFav.list().map((x) => x.h).filter(Boolean);
    }
    // Wishlist King の商品リンク（wk-variant-link / wk-content 等）から拾う
    const links = source.querySelectorAll('a[href^="/products/"]');
    const handles = [];
    links.forEach(a => {
      const h = extractHandle(a.getAttribute('href'));
      if (h && !handles.includes(h)) handles.push(h);
    });
    return handles;
  };

  // プレビュー中はカード取得も同じテーマで行う（本番未切替でも検証できるように）
  const previewId = new URLSearchParams(location.search).get('preview_theme_id');

  // テーマのバージョン。カードの取得URLに付けて、テーマ更新後に古いカードが配信され続けるのを防ぐ
  const themeVer = root.getAttribute('data-wl-ver') || '';

  const fetchCardHTML = async (handle) => {
    let url = `/products/${handle}?sections=${encodeURIComponent(CARD_SECTION)}`;
    if (themeVer) url += `&v=${encodeURIComponent(themeVer)}`;
    if (previewId) url += `&preview_theme_id=${encodeURIComponent(previewId)}&pb=0`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('fetch failed: ' + handle);
    const json = await res.json();
    // { "wl-wishlist-card": "<section>....</section>" } の形式
    return json[CARD_SECTION] || '';
  };

  // ===== 絞り込み・並べ替え =====
  const toolbar   = root.querySelector('[data-wl-toolbar]');
  const filtersEl = root.querySelector('[data-wl-filters]');
  const sortEl    = root.querySelector('[data-wl-sort]');
  const noresult  = root.querySelector('[data-wl-noresult]');
  const resetBtn  = root.querySelector('[data-wl-reset]');
  const sharedHead = root.querySelector('[data-wl-shared-head]');

  // 絞り込みの状態：樹種・サイズは複数選択（OR）。空＝すべて
  const active = { species: new Set(), width: new Set(), available: false };

  const cards = () => Array.from(mount.querySelectorAll('.wl-pair'));

  // 解除した直後は、アプリ側のDOM更新をきっかけにした全体の描き直しを止める。
  // （消したカードだけが静かに消えるようにするため。データの削除自体はアプリが行う）
  let suppressRenderUntil = 0;
  let wkObserver = null;
  const startWatching = () => {
    if (wkObserver && source) wkObserver.observe(source, { childList: true, subtree: true });
  };
  // 解除の間だけ監視を切る。切っている間のアプリ側の書き換えは、再開しても通知されない
  const pauseWatching = (ms) => {
    suppressRenderUntil = Date.now() + ms;
    if (!wkObserver) return;
    wkObserver.disconnect();
    window.clearTimeout(window.__wlTimer);
    window.setTimeout(startWatching, ms);
  };

  // データ源（アプリが差し込んだ一覧）から、その商品の「お気に入り解除」ボタンを探す。
  // アプリのボタンを押すのが、サーバーにも確実に反映される唯一の確実な方法。
  const wkRemoveButtonFor = (handle) => {
    const items = source ? source.querySelectorAll('[data-wk-item]') : [];
    for (const item of items) {
      const link = item.querySelector('a[href^="/products/"]');
      if (link && extractHandle(link.getAttribute('href')) === handle) {
        return item.querySelector('[data-wk-remove-item]');
      }
    }
    return null;
  };

  const cardData = (el) => ({
    species: el.getAttribute('data-wl-species') || '',
    width: el.getAttribute('data-wl-width') || '',
    price: parseInt(el.getAttribute('data-wl-price') || '0', 10), // 並べ替え用
    available: el.getAttribute('data-wl-available') || '0',
  });

  // 幅タグ（例「1600mm~」「1000mm未満」）から並べ替え用の数値を取り出す
  const widthNum = (w) => {
    const m = String(w).match(/(\d+)/);
    if (!m) return 999999;
    return /未満/.test(w) ? parseInt(m[1], 10) - 1 : parseInt(m[1], 10);
  };

  const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  // 選択中の値から、ボタンに出す文言をつくる（未選択なら「すべての〜」）
  const summaryText = (group, allLabel) => {
    const set = active[group];
    if (!set.size) return allLabel;
    const vals = Array.from(set);
    if (vals.length <= 2) return vals.join('・');
    return `${vals[0]}・${vals[1]} 他${vals.length - 2}`;
  };

  // 複数選択プルダウン（開くとチェックボックスが並ぶ）
  // すでに何か選ばれているときは、先頭に「すべて」＝選択を解除して全部に戻す項目を出す
  const mselHtml = (group, allLabel, values) => {
    let opts = '';
    if (active[group].size) {
      opts += `<button type="button" class="wl-msel__all" data-wl-msel-all="${group}">すべて</button>`;
    }
    values.forEach((v) => {
      const on = active[group].has(v) ? ' checked' : '';
      opts += `<label class="wl-msel__opt"><input type="checkbox" data-wl-msel-opt="${group}" value="${esc(v)}"${on}><span>${esc(v)}</span></label>`;
    });
    const active_cls = active[group].size ? ' is-active' : '';
    return `<div class="wl-msel" data-wl-msel="${group}">
      <button type="button" class="wl-msel__btn${active_cls}" aria-expanded="false">
        <span class="wl-msel__summary">${esc(summaryText(group, allLabel))}</span>
      </button>
      <div class="wl-msel__panel" hidden>${opts}</div>
    </div>`;
  };

  // 現在のカードから、実際に存在する選択肢だけを組み立てる
  const buildFilters = () => {
    const species = new Map(); // 値 → 件数
    const widths = new Map();
    let soldout = 0;
    cards().forEach((el) => {
      const d = cardData(el);
      if (d.species) species.set(d.species, (species.get(d.species) || 0) + 1);
      if (d.width) widths.set(d.width, (widths.get(d.width) || 0) + 1);
      if (d.available === '0') soldout++;
    });

    let html = '';
    if (species.size > 1) {
      html += mselHtml('species', '樹種', Array.from(species.keys()));
    }
    if (widths.size > 1) {
      // 幅は狭い順に並べる
      const sorted = Array.from(widths.keys()).sort((a, b) => widthNum(a) - widthNum(b));
      html += mselHtml('width', 'サイズ', sorted);
    }
    if (soldout > 0) {
      const on = active.available ? ' is-on' : '';
      html += `<button type="button" class="wl-chip${on}" data-wl-filter="available" aria-pressed="${active.available}">在庫あり</button>`;
    }
    // 件数は絞り込みの右隣（在庫ありのすぐ横）に置く。絞り込みを組み直すたびに作り直す
    html += `<span class="wl-toolbar__count" data-wl-count></span>`;
    filtersEl.innerHTML = html;
  };

  const matches = (d) => {
    if (active.species.size && !active.species.has(d.species)) return false;
    if (active.width.size && !active.width.has(d.width)) return false;
    if (active.available && d.available !== '1') return false;
    return true;
  };

  const apply = () => {
    const list = cards();
    let shown = 0;
    list.forEach((el) => {
      const ok = matches(cardData(el));
      el.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });

    // 並べ替え（表示中のみ対象。DOM順を入れ替える）
    const sort = sortEl ? sortEl.value : 'added';
    if (sort !== 'added') {
      const visible = list.filter((el) => el.style.display !== 'none');
      visible.sort((a, b) => {
        const pa = cardData(a).price, pb = cardData(b).price;
        return sort === 'price-desc' ? pb - pa : pa - pb;
      });
      visible.forEach((el) => mount.appendChild(el));
    } else {
      // 追加順（元のDOM順）に戻す
      list.slice().sort((a, b) => (a.__wlIndex - b.__wlIndex)).forEach((el) => mount.appendChild(el));
    }

    // 件数は絞り込みバーの中に作り直されるので、そのつど取り直す
    const countNow = root.querySelector('[data-wl-count]');
    if (countNow) countNow.textContent = `${shown}件`;
    if (noresult) noresult.hidden = shown !== 0 || list.length === 0;
  };

  // 複数選択プルダウンの開閉
  const closeAllPanels = (except) => {
    filtersEl.querySelectorAll('.wl-msel').forEach((m) => {
      if (m === except) return;
      m.querySelector('.wl-msel__panel').hidden = true;
      m.querySelector('.wl-msel__btn').setAttribute('aria-expanded', 'false');
      m.classList.remove('is-open');
    });
  };

  if (filtersEl) {
    // プルダウンのボタンで開閉／在庫ありチップの切り替え
    filtersEl.addEventListener('click', (e) => {
      // 「すべて」＝この絞り込みの選択を解除して全部に戻す（パネルは開いたまま）
      const allBtn = e.target.closest('[data-wl-msel-all]');
      if (allBtn) {
        const group = allBtn.getAttribute('data-wl-msel-all');
        active[group].clear();
        const msel = allBtn.closest('.wl-msel');
        msel.querySelectorAll('[data-wl-msel-opt]').forEach((cb) => { cb.checked = false; });
        msel.querySelector('.wl-msel__summary').textContent = group === 'species' ? '樹種' : 'サイズ';
        msel.querySelector('.wl-msel__btn').classList.remove('is-active');
        allBtn.remove();
        apply();
        return;
      }

      const av = e.target.closest('[data-wl-filter="available"]');
      if (av) {
        active.available = !active.available;
        av.classList.toggle('is-on', active.available);
        av.setAttribute('aria-pressed', String(active.available));
        apply();
        return;
      }
      const btn = e.target.closest('.wl-msel__btn');
      if (!btn) return;
      const msel = btn.closest('.wl-msel');
      const panel = msel.querySelector('.wl-msel__panel');
      const willOpen = panel.hidden;
      closeAllPanels(msel);
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      msel.classList.toggle('is-open', willOpen);
    });

    // チェックの切り替え
    filtersEl.addEventListener('change', (e) => {
      const opt = e.target.closest('[data-wl-msel-opt]');
      if (opt) {
        const group = opt.getAttribute('data-wl-msel-opt');
        const value = opt.value;
        if (opt.checked) active[group].add(value); else active[group].delete(value);
        // ボタンの文言と選択中の見た目を更新
        const msel = opt.closest('.wl-msel');
        const allLabel = group === 'species' ? '樹種' : 'サイズ';
        msel.querySelector('.wl-msel__summary').textContent = summaryText(group, allLabel);
        msel.querySelector('.wl-msel__btn').classList.toggle('is-active', active[group].size > 0);

        // 何か選ばれたら「すべて」を出し、選択が空になったら消す
        const panel = msel.querySelector('.wl-msel__panel');
        const existing = panel.querySelector('[data-wl-msel-all]');
        if (active[group].size && !existing) {
          panel.insertAdjacentHTML('afterbegin',
            `<button type="button" class="wl-msel__all" data-wl-msel-all="${group}">すべて</button>`);
        } else if (!active[group].size && existing) {
          existing.remove();
        }

        apply();
      }
    });
  }

  // パネルの外側をクリックしたら閉じる
  document.addEventListener('click', (e) => {
    if (!filtersEl.contains(e.target)) closeAllPanels(null);
  });

  if (sortEl) sortEl.addEventListener('change', apply);
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      active.species.clear(); active.width.clear(); active.available = false;
      buildFilters();
      apply();
    });
  }

  // ===== 選択して共有／相談 =====
  const startBtns     = Array.from(root.querySelectorAll('[data-wl-select-start]'));
  const sharebar      = root.querySelector('[data-wl-sharebar]');
  const shareCountEl  = root.querySelector('[data-wl-share-count]');
  const shareLineBtn  = root.querySelector('[data-wl-share-line]');
  const shareCopyBtn  = root.querySelector('[data-wl-share-copy]');
  const shareNativeBtn= root.querySelector('[data-wl-share-native]');
  const shareCancelBtn= root.querySelector('[data-wl-share-cancel]');
  const shareToast    = root.querySelector('[data-wl-share-toast]');
  const groupShare    = root.querySelector('[data-wl-group-share]');
  const groupConsult  = root.querySelector('[data-wl-group-consult]');
  const shareOpenBtn  = root.querySelector('[data-wl-share-open]');
  const consultOpenBtn= root.querySelector('[data-wl-consult-open]');
  const consultLineBtn= root.querySelector('[data-wl-consult-line]');

  // ポップアップ（問い合わせ／共有）
  const consultModal  = root.querySelector('[data-wl-modal="consult"]');
  const shareModal    = root.querySelector('[data-wl-modal="share"]');
  const consultSelectedEl = root.querySelector('[data-wl-consult-selected]');
  const shareSelectedEl   = root.querySelector('[data-wl-share-selected]');
  // 配信登録（選んだ一枚のご案内をメールで受け取る）
  const groupSignup       = root.querySelector('[data-wl-group-signup]');
  const signupOpenBtn     = root.querySelector('[data-wl-signup-open]');
  const signupModal       = root.querySelector('[data-wl-modal="signup"]');
  const signupSelectedEl  = root.querySelector('[data-wl-signup-selected]');
  const signupForm        = root.querySelector('[data-wl-signup-form]');
  const signupEmail       = root.querySelector('[data-wl-signup-email]');
  const signupErr         = root.querySelector('[data-wl-signup-err]');
  const signupDone        = root.querySelector('[data-wl-signup-done]');
  const SIGNUP_ENDPOINT   = 'https://script.google.com/macros/s/AKfycbz9-xBUD7AsRBvWUGNreXx-Tw7MT9qriTMixMMAo5G-LqFYKhqqt7qt6yofOQgLV0NuBQ/exec';
  const SIGNUP_TOKEN      = 'kido-wl-2026';
  // テスト中は合言葉URL(?wltest=1)のときだけ「案内を受け取る」ボタンを見せる（普通の来訪者には出さない）
  const WL_SIGNUP_TEST = new URLSearchParams(location.search).has('wltest');
  const _signupStartBtn = root.querySelector('[data-wl-select-start="signup"]');
  if (_signupStartBtn && !WL_SIGNUP_TEST) _signupStartBtn.hidden = true;

  const LINE_OFFICIAL = 'https://lin.ee/W7U0MHP'; // 公式LINE
  const canNativeShare = typeof navigator.share === 'function';
  if (shareNativeBtn && canNativeShare) shareNativeBtn.hidden = false;

  let selecting = false;
  let selectMode = null; // 'share' | 'consult'
  const selected = new Set(); // 選択中の handle

  const handleOfCard = (el) => {
    const a = el.querySelector('a[href^="/products/"]');
    return a ? extractHandle(a.getAttribute('href')) : null;
  };

  const updateShareUI = () => {
    const label = selectMode === 'consult' ? '件を選択中' : '件を選択中';
    if (shareCountEl) shareCountEl.textContent = `${selected.size}${label}`;
    const none = selected.size === 0;
    [shareOpenBtn, consultOpenBtn, consultLineBtn, signupOpenBtn]
      .forEach((b) => { if (b) b.disabled = none; });
  };

  const setSelecting = (on, mode) => {
    selecting = on;
    selectMode = on ? (mode || 'share') : null;
    root.classList.toggle('is-selecting', on);
    if (sharebar) sharebar.hidden = !on;
    if (groupShare) groupShare.hidden = !(on && selectMode === 'share');
    if (groupConsult) groupConsult.hidden = !(on && selectMode === 'consult');
    if (groupSignup) groupSignup.hidden = !(on && selectMode === 'signup');
    startBtns.forEach((b) => b.setAttribute('aria-expanded',
      on && b.getAttribute('data-wl-select-start') === selectMode ? 'true' : 'false'));
    if (!on) {
      selected.clear();
      cards().forEach((el) => el.classList.remove('is-selected'));
    }
    updateShareUI();
  };

  // カードをクリックで選択（選択モード中のみ）
  if (mount) {
    mount.addEventListener('click', (e) => {
      // 説明文の「もっと読む」「閉じる」（選択モードでないとき）
      // 実際の文章の高さを使って開閉するので、開くときも閉じるときも同じ速さでふわっと動く
      const dt = e.target.closest('[data-wl-desc-toggle]');
      if (dt && !selecting) {
        e.preventDefault();
        const desc = dt.closest('.wl-pair').querySelector('[data-wl-desc]');
        const willOpen = !desc.classList.contains('is-open');
        if (willOpen) {
          desc.classList.add('is-open');
          desc.style.maxHeight = desc.scrollHeight + 'px';
        } else {
          desc.style.maxHeight = desc.scrollHeight + 'px'; // いまの高さを固定してから畳む
          desc.classList.remove('is-open');
          requestAnimationFrame(() => { desc.style.maxHeight = ''; });
        }
        dt.textContent = willOpen ? '閉じる' : 'もっと読む';
        return;
      }

      // お気に入り解除（選択モードでないとき）
      const rm = e.target.closest('[data-wl-remove]');
      if (rm && !selecting) {
        e.preventDefault();
        const card = rm.closest('.wl-pair');
        const handle = rm.getAttribute('data-wl-handle');
        // 新お気に入りコアに解除を反映する（localStorageへ保存＋会員はメタフィールド同期＋
        // ヘッダー件数更新イベント kido-fav:change を発火）。旧アプリ(Wishlist King)は撤去済みのため
        // そのボタンは押さない。以前は存在しないアプリのボタンを押していたため保存されず、
        // 読み込み直すと復活し、ハートの件数も変わらなかった。
        if (!isDemo && window.__kidoFav && typeof window.__kidoFav.remove === 'function' && handle) {
          window.__kidoFav.remove(handle);
        }
        // 消えるのは押したカード1枚だけ（他のカードはそのまま残す）
        if (card) card.remove();
        // 選択肢と件数を組み直す
        if (toolbar && !isShared) { buildFilters(); }
        apply();
        if (!cards().length) { mount.innerHTML = ''; if (empty) empty.hidden = false; if (toolbar) toolbar.hidden = true; }
        return;
      }

      if (!selecting) return;
      const card = e.target.closest('.wl-pair');
      if (!card) return;
      // カード内リンク・ボタンの動作は止めて選択に使う
      const act = e.target.closest('a, button');
      if (act) e.preventDefault();
      const h = handleOfCard(card);
      if (!h) return;
      if (selected.has(h)) { selected.delete(h); card.classList.remove('is-selected'); }
      else { selected.add(h); card.classList.add('is-selected'); }
      updateShareUI();
    });
  }

  startBtns.forEach((b) => b.addEventListener('click', () => {
    const mode = b.getAttribute('data-wl-select-start');
    // 同じモードのボタンをもう一度押したら解除。違うモードなら切り替え
    if (selecting && selectMode === mode) setSelecting(false);
    else setSelecting(true, mode);
  }));
  if (shareCancelBtn) shareCancelBtn.addEventListener('click', () => setSelecting(false));

  // 選択中の handle を追加順（DOM順）で返す
  const selectedHandles = () => cards().map(handleOfCard).filter((h) => h && selected.has(h));
  // 選択中の商品名（カードのタイトルから）
  const selectedItems = () => cards()
    .filter((el) => selected.has(handleOfCard(el)))
    .map((el) => ({
      handle: handleOfCard(el),
      title: (el.getAttribute('data-wl-title') || (el.querySelector('.wl-title') || {}).textContent || '').trim(),
    }));

  const productURL = (handle) => `${location.origin}/products/${handle}`;

  // 共有する内容＝選んだ「商品ページ」のリンク（お気に入りページのリンクではない）
  const shareBody = () => {
    const items = selectedItems();
    if (items.length === 1) {
      return `${items[0].title}\n${productURL(items[0].handle)}`;
    }
    return items.map((it) => `${it.title}\n${productURL(it.handle)}`).join('\n\n');
  };

  const shareText = () => '鬼童銘木｜気になる一枚板';
  const shareMessage = () => `${shareText()}\n\n${shareBody()}`;

  // LINEで相談：公式アカウント宛に、商品名・商品ページ・お名前・住所・お問合せ内容の雛形を入れて開く
  const lineConsultMessage = () => {
    const items = selectedItems();
    const blocks = items.map((it) => `${it.title}\n▼商品ページ\n${productURL(it.handle)}`);
    return '【この商品について】\n'
      + blocks.join('\n\n')
      + '\nーーーーーーーーーーー\n▶︎お名前：\n▶︎住所：\n▼お問合せ内容をご記入ください。\n';
  };

  const showToast = (msg) => {
    if (!shareToast) return;
    shareToast.textContent = msg;
    shareToast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => { shareToast.hidden = true; }, 2400);
  };

  // 選んだ商品を、モーダル上部に小さく一覧表示する（何について相談/共有するかを明示）
  const renderSelectedList = (el) => {
    if (!el) return;
    const items = selectedItems();
    el.innerHTML = items.map((it) =>
      `<a class="wl-modal__chip" href="${productURL(it.handle)}" target="_blank" rel="noopener">${it.title}</a>`
    ).join('');
  };

  // ===== ポップアップの開閉 =====
  let lastFocused = null;
  const openModal = (modal) => {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.hidden = false;
    // 二重スクロールを防ぐため背景を固定
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => modal.classList.add('is-open'));
  };
  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { modal.hidden = true; }, 250);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  };
  root.querySelectorAll('[data-wl-modal-close]').forEach((b) => {
    b.addEventListener('click', () => closeModal(b.closest('[data-wl-modal]')));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    [consultModal, shareModal, signupModal].forEach((m) => { if (m && !m.hidden) closeModal(m); });
  });

  /* 共有が使われたかを数える（2026-09-15 代表承認）。
     押せるのに数えていなかったため、使われているかどうかが分からなかった。
     **見た目も動きも変えない。**送るだけ。gtag が無い環境でも落ちないようにする。 */
  const shareLog = (name, items) => {
    try {
      if (typeof window.gtag !== 'function') return;
      const xs = items || selectedItems();
      window.gtag('event', name, {
        item_count: xs.length,
        item_id: xs.length === 1 ? xs[0].handle : '',
        item_name: xs.length === 1 ? xs[0].title : ''
      });
    } catch (e) { /* 数えられなくても、共有そのものは止めない */ }
  };

  // ===== 共有ポップ =====
  if (shareLineBtn) shareLineBtn.addEventListener('click', () => {
    if (!selected.size) return;
    shareLog('wishlist_share_line');
    const u = 'https://line.me/R/msg/text/?' + encodeURIComponent(shareMessage());
    window.open(u, '_blank', 'noopener');
  });

  if (shareCopyBtn) shareCopyBtn.addEventListener('click', async () => {
    if (!selected.size) return;
    const items = selectedItems();
    shareLog('wishlist_share_copy', items);
    const text = items.length === 1 ? productURL(items[0].handle) : shareBody();
    try {
      await navigator.clipboard.writeText(text);
      showToast(items.length === 1 ? '商品ページのリンクをコピーしました' : `${items.length}件のリンクをコピーしました`);
    } catch (e) {
      window.prompt('このリンクをコピーしてください', text);
    }
  });

  if (shareNativeBtn) shareNativeBtn.addEventListener('click', async () => {
    if (!selected.size) return;
    const items = selectedItems();
    shareLog('wishlist_share_native', items);
    try {
      if (items.length === 1) {
        await navigator.share({ title: items[0].title, text: items[0].title, url: productURL(items[0].handle) });
      } else {
        await navigator.share({ title: shareText(), text: shareMessage() });
      }
    } catch (e) { /* キャンセル時は何もしない */ }
  });

  // 「共有する」→ 共有ポップを開く
  if (shareOpenBtn) shareOpenBtn.addEventListener('click', () => {
    if (!selected.size) return;
    shareLog('wishlist_share_open');
    renderSelectedList(shareSelectedEl);
    openModal(shareModal);
  });

  // ===== 配信登録ポップ（選んだ一枚のご案内をメールで受け取る）=====
  if (signupOpenBtn) signupOpenBtn.addEventListener('click', () => {
    if (!selected.size) return;
    renderSelectedList(signupSelectedEl);
    if (signupErr) signupErr.hidden = true;
    if (signupDone) signupDone.hidden = true;
    if (signupForm) signupForm.hidden = false;
    openModal(signupModal);
  });

  if (signupForm) signupForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const email = (signupEmail.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (signupErr) { signupErr.textContent = 'メールアドレスをご確認ください。'; signupErr.hidden = false; }
      return;
    }
    if (signupErr) signupErr.hidden = true;
    const items = selectedItems();
    if (!isDemo) {
      items.forEach((it) => {
        const body = new URLSearchParams({
          token: SIGNUP_TOKEN, email: email, product: it.title,
          url: productURL(it.handle), ref: location.href, handle: it.handle,
        });
        // 送信先の応答は読まない（届けば十分）。1商品につき1件のリードとして記録される
        fetch(SIGNUP_ENDPOINT, { method: 'POST', mode: 'no-cors', body: body }).catch(() => {});
      });
    }
    // 以降、商品ページの受け取りパネルは自動で出さない（連絡先はもうあるため）
    try { localStorage.setItem('kido_wl_registered', '1'); } catch (err) {}
    if (signupForm) signupForm.hidden = true;
    if (signupDone) {
      signupDone.textContent = '承りました。選んだ' + items.length + '枚の詳しいご案内をお送りします。';
      signupDone.hidden = false;
    }
  });

  // ===== 問い合わせポップ（商品ページと同じGloboフォーム）=====
  // 送信内容に付ける、選んだ商品名＋リンク（メッセージ欄には最初は表示しない）
  const consultProductInfo = () => {
    const items = selectedItems();
    const blocks = items.map((it) => `${it.title}\n${productURL(it.handle)}`);
    return '【気になっている一枚】\n' + blocks.join('\n\n');
  };

  // Globoフォームの本文欄（textarea）を探す。読み込みが遅いので、現れるまで少し待つ
  const findFormTextarea = () => {
    const box = consultModal ? consultModal.querySelector('.wl-modal__form') : null;
    if (!box) return null;
    return box.querySelector('textarea[name="textarea"]')
        || box.querySelector('textarea[id$="-textarea"]')
        || box.querySelector('textarea');
  };

  // 「問い合わせで相談」→ 問い合わせポップを開く。
  // メッセージ欄は空のまま（お客様が自由に書ける）。商品情報は送信の直前に裏で足す。
  if (consultOpenBtn) consultOpenBtn.addEventListener('click', () => {
    if (!selected.size) return;
    renderSelectedList(consultSelectedEl);
    openModal(consultModal);
  });

  // 送信ボタンが押されたら、メッセージ欄の末尾に商品情報を足してから送る。
  // 画面上は最後まで見せず、送信された内容にだけ含める（capture で送信処理より先に走らせる）。
  if (consultModal) consultModal.addEventListener('click', (e) => {
    const submitBtn = e.target.closest('button[type="submit"], input[type="submit"], [class*="submit"]');
    if (!submitBtn) return;
    if (!selected.size) return;
    const ta = findFormTextarea();
    if (!ta) return;
    if (ta.value.indexOf('【気になっている一枚】') !== -1) return; // 二重付与を防ぐ
    const body = ta.value.trim();
    ta.value = (body ? body + '\n\n' : '') + consultProductInfo();
    ta.dispatchEvent(new Event('input', { bubbles: true }));
    ta.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  // モーダル内の「LINEでも相談」
  const consultLineInModal = root.querySelector('[data-wl-consult-line-inmodal]');
  if (consultLineInModal) consultLineInModal.addEventListener('click', (e) => {
    e.preventDefault();
    if (!selected.size) return;
    const u = `https://line.me/R/oaMessage/${encodeURIComponent('@311cncrr')}/?`
      + encodeURIComponent(lineConsultMessage());
    window.open(u, '_blank', 'noopener');
  });

  if (consultLineBtn) consultLineBtn.addEventListener('click', () => {
    if (!selected.size) return;
    const u = `https://line.me/R/oaMessage/${encodeURIComponent('@311cncrr')}/?`
      + encodeURIComponent(lineConsultMessage());
    window.open(u, '_blank', 'noopener');
  });

  let renderToken = 0; // 再描画が二重に走って重複しないよう、最新の描画だけを反映する
  const render = async () => {
    const token = ++renderToken;
    const handles = getHandlesFromWK();

    // 0件
    if (!handles.length) {
      mount.innerHTML = '';
      empty.hidden = false;
      if (toolbar) toolbar.hidden = true;
      return;
    }
    empty.hidden = true;

    // 先にカードを集めてから一括で差し替える（途中に別の描画が走っても混ざらない）
    const cardEls = [];
    let idx = 0;
    for (const h of handles) {
      try {
        const html = await fetchCardHTML(h);
        if (token !== renderToken) return; // 新しい描画が始まっていたら破棄
        if (html) {
          const wrap = document.createElement('div');
          wrap.innerHTML = html;
          const card = wrap.firstElementChild;
          card.__wlIndex = idx++; // 追加順を保持
          cardEls.push(card);
        }
      } catch (e) {
        // 失敗しても止めない
        console.warn(e);
      }
    }
    if (token !== renderToken) return;
    mount.innerHTML = '';
    cardEls.forEach((el) => mount.appendChild(el));

    // 会員登録のご案内は、お気に入りが1件以上あるときだけ出す（未ログインのときのみ要素が存在する）
    const signup = root.querySelector('[data-wl-signup]');
    if (signup && !isShared) signup.hidden = cardEls.length === 0;

    // 説明文が2行に収まらない商品だけ「もっと読む」を出す
    cardEls.forEach((card) => {
      const desc = card.querySelector('[data-wl-desc]');
      const tog = card.querySelector('[data-wl-desc-toggle]');
      if (!desc || !tog) return;
      if (desc.scrollHeight > desc.clientHeight + 2) tog.hidden = false;
    });

    // コーディネート写真：実際に読み込めた商品だけ右枠を出す（削除済み画像＝404の空枠を出さない）
    cardEls.forEach((card) => {
      const img = card.querySelector('img[data-wl-coord]');
      if (!img) return;
      const right = img.closest('.wl-right');
      const show = () => { if (right) right.hidden = false; };
      const drop = () => { if (right) right.remove(); };
      if (img.complete) { (img.naturalWidth > 0 ? show : drop)(); return; }
      img.addEventListener('load', show);
      img.addEventListener('error', drop);
    });

    // 共有で開かれたときは、絞り込み・共有操作は出さず読み取り専用の一覧にする
    if (isShared) {
      if (sharedHead) sharedHead.hidden = false;
      if (toolbar) toolbar.hidden = true;
      apply();
      return;
    }

    // カードが揃ってから絞り込みバーを組み立てる（選択肢が1種類以下なら出さない）
    if (toolbar) {
      buildFilters();
      // 件数は常に入るので、絞り込みの部品があるかどうかで判定する
      const hasFilters = filtersEl.querySelectorAll('.wl-msel, .wl-chip').length > 0;
      toolbar.hidden = !hasFilters && cards().length < 2;
    }
    apply();
  };

  // WKが後からDOM描画するので、監視して再描画（共有・デモ表示ではWKに依存しないので不要）
  if (!isShared && !isDemo) {
    wkObserver = new MutationObserver(() => {
      // 自分で解除したときは、アプリ側のDOM更新で全部を描き直さない
      // （そのカードだけ消してあるので、描き直すと再読み込みのように見えてしまう）
      if (Date.now() < suppressRenderUntil) return;
      window.clearTimeout(window.__wlTimer);
      window.__wlTimer = window.setTimeout(render, 150);
    });
    startWatching();
  }

  // 会員登録・ログインのクリックをGA4に送る（後から要素が増えても拾えるようデリゲートで）
  // 効果測定：この登録が「問い合わせ・相談」を食っていないかを必ず見る
  const ga = (name, params) => {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  };
  document.addEventListener('click', (e) => {
    const su = e.target.closest('[data-wl-signup-btn]');
    if (su) { ga('wl_signup_click', { location: 'wishlist_page', items: cards().length }); return; }
    const li = e.target.closest('[data-wl-login-btn]');
    if (li) { ga('wl_login_click', { location: 'wishlist_page', items: cards().length }); }
  });

  // 初回
  render();
})();
